import React, { useEffect, useRef, useState, useCallback } from 'react';
import { f_sendSignInLinkToEmail, auth } from '../Util/Firebase';
import { useLocalParticipant, useDevices, useDaily } from '@daily-co/daily-react';
import { pageAtom, topMessageAtom } from '../../State';
import { useSetRecoilState } from 'recoil';
import DataModel from '../Util/DataModel';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { useTranslation } from 'react-i18next';
import { getImagePath } from '../Util/utils';
import { ReactComponent as LogoTextSVG } from '../Images/header/smilelogotext.svg';
export default function BrowserEmail() {
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [emailState, setEmailState] = useState('');
  const [codeState, setCodeState] = useState('');
  const [isSendingState, setIsSendingState] = useState(false);
  const [loginStatusState, setLoginStatusState] = useState('typeEmail');
  const { t, i18n } = useTranslation();
  // useEffect(() => {
  //   emailLinkCheck();
  // }, []);

  // //メール内リンクをクリックして戻ってきた場合の処理
  // async function emailLinkCheck() {
  //   if (f_isSignInWithEmailLink(auth, window.location.href)) {
  //     let email = window.localStorage.getItem('emailForSignIn');
  //     if (!email) {
  //       email = window.prompt('Please provide your email for confirmation');
  //     }
  //     f_signInWithEmailLink(auth, email, window.location.href)
  //       .then(async () => {
  //         //ログイン成功

  //         //DBへの追加とミーティングID取得
  //         const result = await DataModel.signUpWithOneTimeEmail(email);

  //         //エラーの場合
  //         if (result == null) {
  //           //エラー
  //           alert('There is an error, please try from the beginning');
  //         } else {
  //           //ミーティングIDをローカルに保存
  //           localStorage.setItem('meetingID', result.meetingID);

  //           //ローカルストレージを削除
  //           window.localStorage.removeItem('emailForSignIn');
  //         }
  //       })
  //       .catch((error) => {
  //         //エラー
  //         alert('There is an error, please try from the beginning');
  //       });
  //   }
  // }

  const handleChange = (event) => {
    setEmailState(event.target.value);
  };

  const handleCode = (event) => {
    setCodeState(event.target.value);
  };

  const editEmail = () => {
    setLoginStatusState('typeEmail');
  };

  //独自のメールログイン用
  const tapSend = async () => {
    if (emailState != '' && isSendingState == false) {
      //送信中フラグオン
      setIsSendingState(true);

      //メール送信
      const result = await DataModel.mailLogin(emailState);

      //送信中フラグオフ
      setIsSendingState(false);

      if (result != null) {
        setTopMessageState({
          type: 'joined',
          message: t('mypage.Email sent successfully'),
        });

        //コード入力画面へ
        setLoginStatusState('typeCode');
      } else {
        setTopMessageState({
          type: 'joined',
          message: t('mypage.Error something wrong'),
        });
      }
    }
  };

  //Firebaseのメールワンタイムログイン用のメール送信
  const sendEmailFirebase = async () => {
    if (emailState != '' && isSendingState == false) {
      //送信中フラグオン
      setIsSendingState(true);

      var result = false;

      //許可リストをチェック
      if (loginStatusState == 'typeEmail') {
        result = await checkAllowList();
      } else {
        result = await checkAllowList('code', codeState);
      }

      //エラーの場合
      if (result == false) {
        //送信中フラグオン
        setIsSendingState(false);

        if (loginStatusState == 'typeInviteCode') {
          alert(t('mypage.Invitation code is wrong'));
        }

        //招待コード入力画面へ
        setLoginStatusState('typeInviteCode');
        return;
      }

      //トークンを発行
      let r = await DataModel.signUpToken(emailState, i18n.language);
      if (r != null) {
        //ローカルストレージに保存
        localStorage.setItem('emailForSignIn', emailState);

        //送信中フラグオフ
        setIsSendingState(false);

        setTopMessageState({
          type: 'joined',
          message: t('mypage.Email sent successfully'),
        });

        //送信完了画面へ
        setLoginStatusState('typeCode');
      } else {
        setTopMessageState({
          type: 'joined',
          message: t('mypage.Error something wrong'),
        });
      }

      return;

      //メール送信設定(Firebase)
      const actionCodeSettings = {
        url: 'https://faceless.ooo/app',
        handleCodeInApp: true,
      };

      //メールの言語を設定
      auth.useDeviceLanguage();

      //メール送信
      f_sendSignInLinkToEmail(auth, emailState, actionCodeSettings)
        .then(() => {
          //ローカルストレージに保存
          localStorage.setItem('emailForSignIn', emailState);

          //送信中フラグオフ
          setIsSendingState(false);

          setTopMessageState({
            type: 'joined',
            message: t('mypage.Email sent successfully'),
          });

          //送信完了画面へ
          setLoginStatusState('typeCode');
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;

          // console.log(errorMessage);

          setTopMessageState({
            type: 'joined',
            message: t('mypage.Error something wrong'),
          });
        });
    }
  };

  async function checkAllowList(type = 'email', code = null) {
    const result = await DataModel.checkAllowList(emailState, type, code);
    return result;
  }

  // //コード送信ボタンをタップ
  // const tapCode = async () => {
  //   if (codeState != '' && isSendingState == false) {
  //     //送信中フラグオン
  //     setIsSendingState(true);

  //     //コードの確認
  //     const result = await DataModel.checkEmailCode(emailState, codeState);

  //     if (result != null) {
  //       //ログイン処理
  //       //const auth = getAuth();

  //       //ミーティングIDをローカルに保存
  //       localStorage.setItem('meetingID', result.meetingID);

  //       //トークンでのログイン
  //       signInWithCustomToken(auth, result.token)
  //         .then((result) => {
  //           console.log('ログインした');

  //           //送信中フラグオフ
  //           setIsSendingState(false);

  //           setTopMessageState({
  //             type: 'joined',
  //             message: 'Login successfully',
  //           });
  //         })
  //         .catch((error) => {
  //           console.log('エラーだよ');
  //           console.log(error);
  //         });
  //     } else {
  //       //送信中フラグオフ
  //       setIsSendingState(false);

  //       //エラーメッセージ
  //       setTopMessageState({
  //         type: 'joined',
  //         message: 'Error something wrong',
  //       });
  //     }
  //   }
  // };

  const handleKeyDown = (e) => {
    if (e.key !== 'Enter') return;

    //tapSend();

    sendEmailFirebase();
    // if (loginStatusState == 'typeEmail') {
    //   tapSend();
    // } else {
    //   tapCode();
    // }
  };

  //レンダー
  return (
    <>
      <div id="electronEmailWrap">
        <div id="electronEmailInside">
          {/*メール入力画面 */}
          {loginStatusState == 'typeEmail' && (
            <>
              <div className="electronEmailLogo">
                {/* <img src={getImagePath() + '/buttons/loading.webp'} /> */}
                {/* <img src={getImagePath() + '/header/facelesslogo.png'} /> */}
                <LogoTextSVG />
              </div>

              <h1>{t('mypage.Sign Up / Login')} </h1>
              <input
                id="electronEmailInput"
                name="email"
                type="text"
                placeholder={t('mypage.Enter your email address')}
                onChange={(e) => handleChange(e)}
                value={emailState}
                onKeyDown={handleKeyDown}
              />
              <button disabled={emailState != '' ? false : true} onClick={sendEmailFirebase}>
                {isSendingState ? (
                  <>
                    <div id="selectLoader">
                      <svg className="circular-loader" viewBox="25 25 50 50">
                        <circle
                          className="loader-path"
                          cx="50"
                          cy="50"
                          r="20"
                          fill="none"
                          stroke="#70c542"
                          strokeWidth="2"
                        />
                      </svg>
                    </div>
                  </>
                ) : (
                  <>{t('mypage.Send')}</>
                )}
              </button>

              <div id="electronEmailTerm">
                <>{t("mypage.By clicking on 'Send' button, you agree with the")}</>
                <a href="https://faceless.ooo/terms" target="_blank">
                  {t('mypage.Terms')}
                </a>
              </div>
            </>
          )}

          {loginStatusState == 'typeInviteCode' && (
            <>
              {/*コード入力 */}
              <h1>{t('mypage.Type invitation code')}</h1>
              <div id="codeDetail">
                {t('mypage.Your email...')}
                <span id="editEmail" onClick={editEmail}>
                  {t('mypage.change my email.')}
                </span>
              </div>
              <input
                id="electronEmailInput"
                name="email"
                type="text"
                placeholder="Type invitation code"
                onChange={(e) => handleCode(e)}
                value={codeState}
                onKeyDown={handleKeyDown}
              />
              <button disabled={codeState != '' ? false : true} onClick={sendEmailFirebase}>
                {isSendingState ? (
                  <>
                    <div id="selectLoader">
                      <svg className="circular-loader" viewBox="25 25 50 50">
                        <circle
                          className="loader-path"
                          cx="50"
                          cy="50"
                          r="20"
                          fill="none"
                          stroke="#70c542"
                          strokeWidth="2"
                        />
                      </svg>
                    </div>
                  </>
                ) : (
                  <>{t('mypage.Send')}</>
                )}
              </button>

              <div id="electronNoCode">
                <a href="https://faceless.ooo/access">
                  <>{t('mypage.Get an access passs now!')}</>
                </a>
              </div>
            </>
          )}

          {loginStatusState == 'typeCode' && (
            <>
              {/*コード入力 */}
              <h1 style={{ marginTop: '200px' }}>{t('mypage.We have sent you an email!')}</h1>
              <div id="codeDetail">
                <>{t('mypage.Please check...')}</>

                <span id="editEmail" onClick={editEmail}>
                  <>{t('mypage.change my email.')}</>
                </span>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
